module.exports = __webpack_public_path__ + "static/media/helmet-battle.dc331669.svg";